import { DateTimeRange } from '@modules/common/components/DateRangePicker/types';
import { useIsSearchToFeedEnabled } from '@modules/common/hooks';
import { getUseInSearchLink } from '@modules/feed/utils/getUseInSearchLink';
import { OpenInNewRounded } from '@mui/icons-material';
import { Button, ButtonProps } from '@mui/material';
import { Link } from 'react-router-dom';
import { createAnalyticsTracker } from 'v2/analytics/events';
import { QueryContainer } from 'v2/core/services/notebook/types';

const trackOpenInFeed = createAnalyticsTracker('openInFeed');

interface OpenInSearchButtonProps {
  queryContainer: QueryContainer;
  size?: ButtonProps['size'];
  prompt?: string;
}

export const OpenInSearchButton = ({
  queryContainer,
  size = 'medium',
  prompt,
}: OpenInSearchButtonProps) => {
  const isSearchToFeedEnabled = useIsSearchToFeedEnabled();

  const feedLink = getUseInSearchLink({
    duration: queryContainer.DateRange as DateTimeRange,
    where: queryContainer.WhereClause,
    isSearchToFeedEnabled,
    prompt,
  });

  const onClick = () => {
    trackOpenInFeed({
      eventName: 'Open in Feed Button Clicked',
      openedFromURL: window.location.pathname,
      feedURL: `${feedLink.pathname}?${feedLink.search}`,
    });
  };

  return (
    <Button
      component={Link}
      variant="outlined"
      size={size}
      to={feedLink}
      target="_blank"
      startIcon={<OpenInNewRounded />}
      sx={{
        whiteSpace: 'nowrap',
        minWidth: 'max-content',
      }}
      onClick={onClick}
    >
      Open in {isSearchToFeedEnabled ? 'Feed' : 'Search'}
    </Button>
  );
};
